import { mmkv } from '@/storage/mmkv';
import { nanoid } from 'nanoid/non-secure';

const DEVICE_KEY = 'sync.deviceId';

/** A stable per-install device id (persisted in MMKV). Used to tie-break LWW conflicts. */
export function deviceId(): string {
  let id = mmkv.getString(DEVICE_KEY);
  if (!id) {
    id = nanoid();
    mmkv.setString(DEVICE_KEY, id);
  }
  return id;
}

/** A fresh id for an offline-minted record (stable so the same id syncs to the cloud). */
export function newRecordId(): string {
  return nanoid();
}
